export class GraphicObjectCreator {
  constructor() {
    this.callbackPlaces = ["beforeCreate", "afterCreate"];
    this.callbacks = new Map();
    this.callbackPlaces.forEach(place => this.callbacks.set(place, []));
  }

  addCallback(place, callback) {
    let placeCallbacks = this.callbacks.get(place);
    if (placeCallbacks === undefined) {
      return;
    }
    placeCallbacks.push(callback);
  }

  applyCallbacks(place) {
    let placeCallbacks = this.callbacks.get(place);
    placeCallbacks?.forEach(callback => callback(this));
  }

  create(/*settings*/) {
    return undefined;
  }
}
